import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './App.css';
import { FaWhatsapp, FaTimes, FaBars, FaAndroid, } from 'react-icons/fa';
import { FiCode } from 'react-icons/fi';
import { FiLayout } from 'react-icons/fi';
import { FiFacebook } from "react-icons/fi";
import { TfiTwitter } from "react-icons/tfi";
import { FiLinkedin } from "react-icons/fi";
import { TiArrowUpOutline } from "react-icons/ti";
import { FaUpRightFromSquare } from "react-icons/fa6"

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const texts = ["Frontend Developer", "MERN Stack Developer", "Full Stack Developer"];
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    console.log("Effect triggered!");
    const interval = setInterval(() => {
      console.log("Changing text...");
      setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 2000); // Change text every 2 seconds

    return () => clearInterval(interval);
  }, [texts]);
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      const scrollPosition = window.scrollY;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNumber: '',
    emailSubject: '',
    message: '',
  });

  const MySwal = withReactContent(Swal); // Enhancing compatibility with React

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      fullName: '',
      email: '',
      mobileNumber: '',
      emailSubject: '',
      message: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    try {
      const response = await axios.post('http://localhost:3001/send-email', formData);

      if (response.status === 200) {
        MySwal.fire({
          title: 'Success!',
          text: 'Email sent successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          resetForm(); // Reset form fields upon success
        });
      } else {
        MySwal.fire({
          title: 'Oops...',
          text: 'Something went wrong. Please try again.',
          icon: 'warning',
          confirmButtonText: 'Try Again',
        });
      }

      console.log('Email sent:', response.data);
    } catch (error) {
      console.error('Error sending email:', error);

      MySwal.fire({
        title: 'Error',
        text: 'Error sending email. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };


  return (
    <div>
      <header className="header">
        <a href="#" className="logo">ABHIJIT SAHOO</a>
        <div className={menuOpen ? 'icon close-icon' : 'icon menu-icon'} id="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
        <nav className={menuOpen ? 'navbar active' : 'navbar'}>
          <a href="#home" className={activeSection === 'home' ? 'active' : ''}>Home</a>
          <a href="#about" className={activeSection === 'about' ? 'active' : ''}>About</a>
          <a href="#services" className={activeSection === 'services' ? 'active' : ''}>Services</a>
          <a href="#portfolio" className={activeSection === 'portfolio' ? 'active' : ''}>Portfolio</a>
          <a href="#education" className={activeSection === 'education' ? 'active' : ''}>Education</a>
          <a href="#skills" className={activeSection === 'skills' ? 'active' : ''}>Skills</a>
          <a href="#contact" className={activeSection === 'contact' ? 'active' : ''}>Contact</a>
        </nav>
      </header>
      <section className="home" id="home">
        <div className="home-content">
          <h1>Hi, I'm <span>Abhijit Sahoo</span></h1>

          <div className="text-animate">
            <h3>And I'm a</h3>
            <h3>Frontend Developer</h3>
          </div>

          <p>
            As a Frontend Developer, I specialize in building responsive, interactive, and high-performance web applications.
            With expertise in React.js, Next.js, JavaScript, Tailwind CSS, and Material-UI, I create seamless user experiences
            that bridge the gap between design and functionality.
          </p>

          <p>
            Passionate about UI/UX design, I focus on clean, efficient, and scalable code, ensuring optimal performance
            and accessibility across all devices.
          </p>

          <div className="btn-box">
            <a href="/Abhijit_Sahoo_React_Frontend_Developer.pdf" className="btn">Download CV</a>
            <a href="#contact" className="btn">Let's Talk</a>
          </div>
        </div>

        <div className="home-sci">
          <a href="https://www.facebook.com/abhijit.kumar.161214?mibextid=ZbWKwL" target="_blank"><FiFacebook size={30} /></a>
          <a href="https://twitter.com/" target="_blank"><TfiTwitter size={30} /></a>
          <a href="https://linkedin.com/in/abhijit-sahoo-697913261" target="_blank"><FiLinkedin size={30} /></a>
          <a href="https://wa.me/9114126106" target="_blank"><FaWhatsapp size={30} /></a>
        </div>
        <div className="home-imgHover"></div>
      </section>
      <section className="about" id="about">
        <h2 className="heading">About <span>Me</span></h2>
        <div className="about-img">
          <img src="/Abhijit.png" alt="" />
          <span className="circle-spin"></span>
        </div>
        <div className="about-content">
          <h3>{texts[currentTextIndex]}</h3>
          <p  >

            Experienced Frontend Developer with 1.5 years of expertise in building responsive, user-centric web applications using modern technologies
            like Next.js and React.js. Proficient in frameworks such as Tailwind CSS, Material UI, and Bootstrap, with strong skills in JavaScript, HTML, and CSS. Demonstrated leadership in managing development teams, delivering high-quality, scalable solutions, and optimizing code for performance. Skilled in API integration, state management, and ensuring seamless communication between frontend and backend systems. A collaborative team player with a focus on innovative solutions and adaptability to new technologies

          </p>
          <div className="btn-box btns">
            <a href="#" className="btn">Read More</a>
          </div>
        </div>
      </section>
      <section className="services" id="services">
        <h2 className="heading">My <span>Services</span></h2>

        <div className="services-container">

          <div className="services-box">
            <FiCode size={40} />
            <h3>Web Development</h3>
            <p className="service-text">
              I build responsive, high-performance web applications using <b>React.js, Next.js, JavaScript, and Material-UI</b>.
              Specializing in dynamic UI development, API integration, and optimizing page load speed for seamless user experiences.
            </p>
            <div className="btn-box btns">
              <a href="#" className="btn">Read More</a>
            </div>
          </div>


          {/* <div className="services-box">
          <FaAndroid size={40} />
          <h3>App Development</h3>
          <p className="service-text">
            I develop cross-platform mobile applications using <b>React Native</b> with smooth UI, seamless navigation, and 
            efficient data handling. Experience in integrating APIs, real-time data synchronization, and performance optimization.
          </p>
          <div className="btn-box btns">
            <a href="#" className="btn">Read More</a>
          </div>
        </div> */}
          <div className="services-box">
            <FiLayout size={40} />
            <h3>UI/UX Designing</h3>
            <p className="service-text">
              I craft visually appealing and user-friendly interfaces with <b>Figma, Adobe XD, Tailwind CSS, and Material-UI</b>.
              Expertise in wireframing, prototyping, and creating accessible and modern web layouts for an optimal user experience.
            </p>
            <div className="btn-box btns">
              <a href="#" className="btn">Read More</a>
            </div>
          </div>
        </div>
      </section>
      <section class="portfolio" id="portfolio">
        <h2 class="heading">Latest <span>Projects</span></h2>
        <div class="portfolio-container">
          {/* <!-- Repeat the following block for each project --> */}
          <div class="portfolio-box">
            <img src="/sparrow1.jpeg" alt="" />
            <div class="portfolio-layer">
              <h4>Sparrow Academic Management System</h4>
              <p>The Sparrow Academic Management System is a comprehensive
                college management platform designed to digitize and streamline academic operations for educational institutions. It provides a centralized solution for handling student records, faculty management,
                course scheduling, and real-time academic monitoring.</p>
              <FaUpRightFromSquare />
            </div>
          </div>
          <div class="portfolio-box">
            <img src="/2.jpg" alt="" />
            <div class="portfolio-layer">
              <h4>PAPL - House Rent & HRMS System</h4>
              <p>PAPL (Plant-Side Employee Housing & HRMS) is a comprehensive management system designed to streamline employee housing allocation and human resource operations. It combines a House Rent Management System for assigning accommodations to plant-side employees and a Human Resource Management System (HRMS) to digitally manage workforce processes
                such as payroll, attendance, and performance tracking.</p>
              <FaUpRightFromSquare />
            </div>
          </div>
          <div class="portfolio-box">
            <img src="/bloodbank.jpeg" alt="" />
            <div class="portfolio-layer">
              <h4>Online Blood Bank</h4>
              <p>The Online Blood Bank System is a web-based platform designed to streamline blood donation, storage, and distribution. This system connects donors, recipients, and blood banks, ensuring quick and efficient access to blood supplies in times of emergency.</p>
              <FaUpRightFromSquare />
            </div>
          </div>
        </div>
      </section>

      <section className="education" id="education">
        <h2 className="heading">My <span>Journey</span></h2>
        <div className="education-row">
          <div className="education-column">
            <h3 className="title">Education</h3>
            <div className="education-box">
              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> 2015-2017 </div>
                  <h3>Intermediate – Council of Higher Secondary Education (CHSE) ODISHA with </h3>
                  <p>55% at Vinayak College of Science and Commerce, Bhadrak. </p>
                </div>
              </div>
              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> 2017-2020 </div>
                  <h3>Bachelor in Science in Computer Science with</h3>
                  <p>71% at Chitalo Degree Mahavidyalaya, Jajpur Town. </p>
                </div>
              </div>
              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> 2021-2023 </div>
                  <h3>Master in Computer Application (MCA) with </h3>
                  <p>8.75CGPA at
                    NIIS Institute of Business Administration, Bhubaneswar.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="education-column">
            <h3 className="title">Experience</h3>
            <div className="education-box">

              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> July 2023 - Present</div>
                  <h3>Frontend Developer - AbsecLab Pvt. Ltd</h3>
                  <p>Developed responsive and interactive user interfaces using React.js and Next.js, optimizing performance and enhancing user experience.</p>
                </div>
              </div>


              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> 2024 - Present</div>
                  <h3>Project: Sparrow Academic Management System</h3>
                  <p>Worked on a robust College Management System, leading frontend development using React.js, Next.js, and Material UI.</p>
                  <p>Collaborated with backend developers to integrate RESTful APIs, ensuring seamless data flow and system functionality.</p>
                </div>
              </div>


              <div className="education-content">
                <div className="content">
                  <div className="year"><i className='bx bxs-calendar'></i> 2023 - Present</div>
                  <h3>Project: PAPL - House Rent & HRMS System</h3>
                  <p>Developed a House Rent Management System and HRMS platform using React.js, Next.js, and Java Spring Boot.</p>
                  <p>Implemented real-time data visualization components for municipal metrics, improving decision-making and operational efficiency.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="skills" id="skills">
        <h2 className="heading">My <span>Skills</span></h2>
        <div className="skills-row">
          <div className="skills-column">
            <h3 className="title">Coding Skills</h3>
            <div className="skills-box">
              <div className="skills-content">
                <div className="progress">
                  <h3>HTML <span>100%</span></h3>
                  <div className="bar"><span style={{ width: '90%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>CSS <span>80%</span></h3>
                  <div className="bar"><span style={{ width: '80%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>JavaScript <span>75%</span></h3>
                  <div className="bar"><span style={{ width: '75%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>React <span>90%</span></h3>
                  <div className="bar"><span style={{ width: '80%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>Next <span>80%</span></h3>
                  <div className="bar"><span style={{ width: '80%' }}></span></div>
                </div>
              </div>
            </div>
          </div>
          <div className="skills-column">
            <h3 className="title">Professional Skills</h3>
            <div className="skills-box">
              <div className="skills-content">
                <div className="progress">
                  <h3>Web Design <span>80%</span></h3>
                  <div className="bar"><span style={{ width: '80%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>Web Development <span>50%</span></h3>
                  <div className="bar"><span style={{ width: '50%' }}></span></div>
                </div>
                {/* <div className="progress">
                  <h3>Graphic Design <span>30%</span></h3>
                  <div className="bar"><span style={{ width: '30%' }}></span></div>
                </div>
                <div className="progress">
                  <h3>Marketing <span>40%</span></h3>
                  <div className="bar"><span style={{ width: '40%' }}></span></div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="contact" id="contact">
        <h2 class="heading">Contact <span>Me!</span></h2>
        <form onSubmit={handleSubmit}>
          <div class="input-box">
            <div class="input-field">
              <input type="text" name="fullName" placeholder="Full Name" required value={formData.fullName} onChange={handleChange} />
              <span class="focus"></span>
            </div>
            <div class="input-field">
              <input type="email" name="email" placeholder="Email Address" required value={formData.email} onChange={handleChange} />
              <span class="focus"></span>
            </div>
          </div>
          <div class="input-box">
            <div class="input-field">
              <input type="tel" name="mobileNumber" placeholder="Mobile Number" required value={formData.mobileNumber} onChange={handleChange} />
              <span class="focus"></span>
            </div>
            <div class="input-field">
              <input type="text" name="emailSubject" placeholder="Email Subject" required value={formData.emailSubject} onChange={handleChange} />
              <span class="focus"></span>
            </div>
          </div>
          <div class="textarea-field">
            <textarea name="message" cols="30" rows="10" placeholder="Your Message" required value={formData.message} onChange={handleChange} />
            <span class="focus"></span>
          </div>
          <div class="btn-box btns">
            <button type="submit" class="btn">Submit</button>
          </div>
        </form>
      </section>
      <footer className="footer">
        <div className="footer-text">
          <p>copyright © 2025 by@abhijit  || Jay Jagannath.</p>
        </div>
        <div className="footer-iconTop">
          <a href="#"><TiArrowUpOutline size={30} /></a>
        </div>
      </footer>
    </div>
  );
}

export default App;
